<template>
	<div>
    <Header />

    <content>
      <Section1 class="nav" id="inicio" />
      <Section2 class="nav" />
      <Section3 class="nav" id="empiricus-pass" />
      <Section4 class="nav" id="series" />
      <Section5 class="nav" id="bonus" />
      <Section6 class="nav" id="contact" />
      <Faq id="faq"></Faq>
    </content>

    <Footer />
	</div>
</template>

<script>
import Faq from '@/components/Section/Faq'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import Section1 from '@/components/Section/Section1'
import Section2 from '@/components/Section/Section2'
import Section3 from '@/components/Section/Section3'
import Section4 from '@/components/Section/Section4'
import Section5 from '@/components/Section/Section5'
import Section6 from '@/components/Section/Section6'

export default {
	components: {
		Faq,
    Footer,
    Header,
		Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Section6,
	},
  computed: {
    empiricusURL () {
      return `${process.env.APP_PUBLICACOES}`
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/LandingPage.vue